import axios from '@/plugins/Axios'
import Mapper from './Mapper'

function Requests () {
  async function fetchCategories () {
    try {
      const { data } = await axios.get('/categories')
      return Mapper.categories(data.categories)
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchTopCategories () {
    try {
      const { data } = await axios.get('/top-categories')
      return data.categories.map(category => {
        return {
          id: category.id_token,
          name: category.category_name,
          slug: category.category_slug
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchFeaturedCategories () {
    try {
      const { data } = await axios.get('/featured-categories')
      return data.categories.map(category => {
        return {
          id: category.category_id_token,
          name: category.category_name
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  return {
    fetchCategories,
    fetchTopCategories,
    fetchFeaturedCategories
  }
}

export default Requests()